import { useApp } from '@/context/AppContext';

export default function Toast() {
  const { toast } = useApp();
  if (!toast) return null;
  return (
    <div className={`toast ${toast.ok ? 'toast-ok' : 'toast-err'}`}>
      {toast.ok ? '✓ ' : '✗ '}{toast.msg}
    </div>
  );
}
